"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = exports.DEFAULT_SERVER_ERROR_MESSAGE = exports.UNKNOWN_REQUEST_ERROR_MESSAGE = void 0;
const rxjs_1 = require("rxjs");
const ajax_1 = require("rxjs/ajax");
const operators_1 = require("rxjs/operators");
exports.UNKNOWN_REQUEST_ERROR_MESSAGE = 'Unknown request error';
exports.DEFAULT_SERVER_ERROR_MESSAGE = 'Server response with error';
var BODY_ENCODER;
(function (BODY_ENCODER) {
    BODY_ENCODER[BODY_ENCODER["json"] = 0] = "json";
    BODY_ENCODER[BODY_ENCODER["formData"] = 1] = "formData";
})(BODY_ENCODER || (BODY_ENCODER = {}));
const encodeToFormData = (data) => {
    return Object.keys(data && typeof data === 'object' ? data : {}).reduce((acc, key) => {
        const value = data[key];
        if (value !== undefined) {
            acc.append(key, value);
        }
        return acc;
    }, new FormData());
};
const encodeBody = (data, encoder) => {
    switch (encoder) {
        case BODY_ENCODER.json:
            return JSON.stringify(data);
        case BODY_ENCODER.formData:
            return encodeToFormData(data);
        default:
            return data;
    }
};
class Request {
    constructor(token, requestManager, options = {}) {
        var _a;
        this.prefix = ((options || {}).prefix || '').replace(/\/+$/, '');
        this.headers = (_a = (options || {}).headers) !== null && _a !== void 0 ? _a : {};
        this.execute = (method, url, data, executeOptions) => requestManager
            .run(() => (0, rxjs_1.from)(token.getToken()).pipe((0, operators_1.switchMap)((accessToken) => {
            let body;
            let contentType;
            const encoderType = (executeOptions || {}).fileUpload
                ? BODY_ENCODER.formData
                : BODY_ENCODER.json;
            if (data && !(executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.requestEncoder)) {
                body = encodeBody(data, encoderType);
            }
            if (data && (executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.requestEncoder)) {
                const encodedRequest = executeOptions.requestEncoder(data);
                body = encodedRequest.data;
                contentType = encodedRequest.contentType;
            }
            const config = {
                body,
                crossDomain: true,
                headers: Object.assign(Object.assign({}, this.headers), { Authorization: `Bearer ${accessToken}` }),
                method: method.toUpperCase(),
                url: this.createUrl(url)
            };
            if (encoderType !== BODY_ENCODER.formData) {
                config.headers['Content-Type'] = contentType || 'application/json';
            }
            return (0, ajax_1.ajax)(config);
        })))
            .pipe((0, operators_1.map)((result) => ({
            data: result.response || null,
            meta: {
                status: result.status
            }
        })), (0, operators_1.take)(1), (0, operators_1.catchError)((err) => {
            // eslint-disable-next-line no-param-reassign
            err.displayMessage =
                (err.status && err.response && err.response.message) ||
                    (err.status
                        ? exports.DEFAULT_SERVER_ERROR_MESSAGE
                        : exports.UNKNOWN_REQUEST_ERROR_MESSAGE);
            return (0, rxjs_1.throwError)(err);
        }));
    }
    createUrl(url) {
        return `${this.prefix}/${url.replace(/^\/+/, '')}`;
    }
}
exports.Request = Request;
//# sourceMappingURL=Request.js.map